/* src/app/forms/cron-form/cron-form.component.scss */
.button-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 10px;
  gap: 10px;
}
/*# sourceMappingURL=cron-form.component.css.map */
